import posthog from 'posthog-js';
import { isProdHost } from './utils/environment';

// Project keys are public (they ship in the bundle either way). Switch on the
// runtime hostname, exactly like public-tools-js, so only the production widget
// reaches the Consumers project.
//
// This deliberately does NOT key off NODE_ENV: every deployed build is a
// production build, so public-tools-js shipped the Production key to its dev
// site and dead-code-eliminated the sandbox branch out of the bundle entirely.
//
// Note the fallthrough runs opposite to the API's. An unrecognised host gets
// the production API (so an unknown deployment still takes bookings) but the
// Sandbox key (so it cannot pollute Consumers). Each default fails in the
// direction that costs least.
const CONSUMERS_KEY = 'phc_rawhM8hWCqxC3BQC3M5aFomk6gEWA6kuBdzVBfVTnuUH';
const SANDBOX_KEY = 'phc_xRAXu64AeRmZHhVqk37gAKmDceDgikzsJkxqg7xRQXhr';

const API_KEY = process.env.REACT_APP_POSTHOG_API_KEY || (isProdHost() ? CONSUMERS_KEY : SANDBOX_KEY);
const API_HOST = process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com';

// The people in this widget are consumers booking with one of Cinch's
// customers. They never log in, never become a Cinch user, and have no
// relationship with Cinch at all — so nothing here builds a profile of them:
//
//   person_profiles 'never'   no person is created for a consumer
//   autocapture false         only the events this widget names are sent
//   capture_pageview/leave    same; the widget reports its own steps instead
//   disable_session_recording the form collects a name, phone and email
//   persistence 'memory'      the widget runs in a cross-origin iframe where
//                             storage is partitioned or blocked anyway, and
//                             writing cookies on a customer's domain invites
//                             a consent question we have no reason to raise.
//                             Visits are joined on booking_session_id, which
//                             the server issues, so nothing depends on storage.
posthog.init(API_KEY, {
  api_host: API_HOST,
  person_profiles: 'never',
  autocapture: false,
  capture_pageview: false,
  capture_pageleave: false,
  disable_session_recording: true,
  disable_surveys: true,
  persistence: 'memory',
  // No feature flags are evaluated here; skipping the request keeps a
  // consumer's first paint free of an analytics round-trip.
  advanced_disable_decide: true,
  // Non-prod only, same as public-tools-js: send each capture immediately so
  // QA can see events hit the wire, and let headless browsers through so the
  // funnel can be driven end-to-end. Production keeps batching for efficiency
  // and keeps dropping bot traffic.
  ...(!isProdHost() && {
    request_batching: false,
    opt_out_useragent_filter: true,
  }),
});

export default posthog;
